import { useCallback, useEffect, useState } from 'react';
import { Typography, message } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import AppCard from '../../../components/cards/AppCard';
import ParamListView from '../../../components/ParamListView';
import { getAllUsers } from '../../../services/adminApi';
import '../../../styles/UserSettingsSection.css';

const { Text } = Typography;

function getUserDisplayName(raw) {
  return (
    raw?.USER_NAME ?? raw?.user_name ?? raw?.username ??
    raw?.name      ?? raw?.full_name ?? raw?.fullName ??
    raw?.email     ?? `User ${raw?.USER_ID ?? raw?.user_id ?? '?'}`
  );
}

function normalizeUserRecord(raw) {
  return {
    ...raw,
    key:      raw.USER_ID   ?? raw.user_id   ?? raw.userId ?? raw.id ?? raw._id,
    _name:    getUserDisplayName(raw),
    _email:   raw.email     ?? raw.EMAIL     ?? raw.user_email ?? '',
    _role:    raw.role_name ?? raw.roleName  ?? raw.ROLE_NAME  ?? '',
    _rawRef:  raw,
  };
}

export default function UsersSection() {
  const [users, setUsers]               = useState([]);
  const [total, setTotal]               = useState(0);
  const [loading, setLoading]           = useState(false);
  const [page, setPage]                 = useState(1);
  const [pageSize, setPageSize]         = useState(10);
  const [searchQuery, setSearchQuery]   = useState('');

  const fetchUsers = useCallback(async ({ offset, limit, searchQuery: sq } = {}) => {
    setLoading(true);
    try {
      const result = await getAllUsers({ offset, limit, searchQuery: sq ?? '' });
      const normalized = (result.users ?? []).map(normalizeUserRecord);
      setUsers(normalized);
      setTotal(result.total ?? normalized.length);
    } catch {
      message.error('Failed to load users');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    queueMicrotask(() => {
      fetchUsers({ offset: (page - 1) * pageSize, limit: pageSize, searchQuery });
    });
  }, [fetchUsers, page, pageSize, searchQuery]);

  const fields = [
    {
      label: 'Name', value: '_name', width: 220,
      render: (name, record) => (
        <div>
          <Text strong style={{ fontSize: 13 }}>{name}</Text>
          {record._email && <div style={{ fontSize: 11, color: 'var(--color-text-muted)' }}>{record._email}</div>}
        </div>
      ),
    },
    { label: 'Role', value: '_role', width: 180 },
  ];

  return (
    <AppCard icon={<TeamOutlined />} title="Users"
      style={{ marginBottom: 0 }}
      bodyStyle={{ padding: 0 }}>
      <ParamListView
        listName="Users"
        dataSource={users}
        fields={fields}
        loading={loading}
        total={total}
        current={page}
        pageSize={pageSize}
        onPageChange={(p) => setPage(p)}
        onPageSizeChange={(s) => { setPageSize(s); setPage(1); }}
        onSearch={(q) => { setSearchQuery(q); setPage(1); }}
      />
    </AppCard>
  );
}
